import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=4558d4e9&"
import script from "./ProductSection.vue?vue&type=script&lang=js&"
export * from "./ProductSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports